// /src/ui/primitives/Badge.tsx

import type { ReactNode } from "react";

export function Badge({
  children,
  variant = "solid",
  className = "",
}: {
  children: ReactNode;
  variant?: "solid" | "soft" | "bright" | "meta";
  className?: string;
}) {
  const base =
    "inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset";

  var styles;
  switch (variant) {
    case "soft":
      styles = "bg-primary/10 text-fg ring-border";
      break;
    case "solid":
      styles = "bg-primary text-primaryFg ring-primary";
      break;
    case "bright":
      styles = "bg-white/85 text-primary ring-white";
      break;
    case "meta":
      styles = "bg-bg text-muted ring-border border border-border";
      break;
    default:
      styles = "bg-primary text-primaryFg ring-primary";
  }

  return <span className={`${base} ${styles} ${className}`}>{children}</span>;
}
